var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{ref:"namo",staticStyle:{"width":"100%","height":"100%","overflow":"hidden","border":"0"},attrs:{"src":_vm.src}})
}
var staticRenderFns = []

export { render, staticRenderFns }